import ScoringHeader from "./ScoringHeader";
export default ScoringHeader;
